import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {AllScoresWidgetPlaceholder} from "./all-scores-widget.placeholder";

const AllScoresWidgetAsyncComponent = AsyncComponent(async () => import('./all-scores-widget' /* webpackChunkName: "all-scores-widget" */ ));

export const AllScoresWidgetAsync = (props) => {
  return <React.Suspense fallback={<AllScoresWidgetPlaceholder {...props}/>}>
    <AllScoresWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
